
import { ErrorMessage, Field } from 'vee-validate';
import { computed } from 'vue';

export function readUrlParams( href = window.location.href ) {
	const url = new URL( href ); // get current url
	const params = new URLSearchParams( url.search ); // get query string as URLSearchParams object
	return Object.fromEntries( params ); // convert to dictionary object
}

export const ReturnFieldComponent = {
	props: {
		name: String,
		modelValue: null,
		label: String,
		type: String,
		rules: null,
		as: String,
		small: Boolean,
		maxlength: Number,
	},
	emit: [
		'update:modelValue'
	],
	setup( props, { emit } ) {
		const value = computed( {
			get: () => props.modelValue,
			set: v => emit( 'update:modelValue', v )
		} );
		return {
			value,
			small: props.small,
			validateOnInput: props.validateOnInput ?? true,
			maxlength: props.maxlength ?? undefined
		};
	},
	template: `
		<Field :name="name" :rules="rules" v-model="value" v-slot="{ field, meta }" :validateOnInput="validateOnInput">
			<div class="input" :class="{ small, ...meta }">
				<input :type="type" :id="name" v-bind="field" class="input__field" placeholder=" " :maxlength="maxlength" />
				<label :for="name" class="input__label">{{ label }}</label>
				<ErrorMessage :name="name" class="error-message" />
			</div>
		</Field>
	`,
	components: {
		Field,
		ErrorMessage
	}
}

export const ReturnSelectComponent = {
	props: {
		name: String,
		modelValue: null,
		label: String,
		rules: null,
		small: Boolean,
		options: Array,
	},
	emit: [
		'update:modelValue'
	],
	setup( props, { emit } ) {
		const value = computed( {
			get: () => props.modelValue,
			set: v => emit( 'update:modelValue', v )
		} );
		return {
			value,
			small: props.small,
			validateOnInput: true,
		};
	},
	template: `
		<Field :name="name" :rules="rules" v-model="value" v-slot="{ field, meta }" :validateOnInput="validateOnInput">
			<div class="input input--select" :class="{ small, ...meta }">
				<div class="select-wrapper">
					<select :id="name" v-bind="field" class="select" :class="{ 'has-value': !!value }">
						<option value="" disabled hidden></option>
						<option v-for="option in options" :key="option.value ?? option" :value="option.value ?? option">
							{{ option.label ?? option }}
						</option>
					</select>
					<svg focusable="false" width="12" height="8" viewBox="0 0 12 8">
						<path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="2"></path>
					</svg>
				</div>
				<label :for="name" class="input__label">{{ label }}</label>
				<ErrorMessage :name="name" class="error-message" />
			</div>
		</Field>
	`,
	components: {
		Field,
		ErrorMessage
	}
}
